module.exports = __webpack_public_path__ + "static/image-20220523-192105-7697e5f26c6c94a4fdcf4303b17f19bf.png";